import * as React from "react";
import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import { IconButton, DialogContent, DialogActions, Alert } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import { useState } from "react";
import CustomConfirmation from "src/components/CustomConfirmation";
import AddWorkoutCalender from "../AddWorkoutCalender";

export default function EditWorkoutPopup({
  open,
  setOpen,
  date,
  programme,
  data,
  reloadList,
  day,
  member_vdot,
  memberRewardData,
  events,
  setEvents,
  setEditWorkputData,
  setSubmitted,
}) {
  const [openCloseDialog, setOpenCloseDialog] = useState(false);
  const childRef = React.useRef();
  const [modalChangeExe, setModalChangeExe] = useState(false);
  const [isloading, setIsLoading] = useState(false);
  const [questionsToSend, setQuestionsToSend] = useState([]);
  const [editShow, setEditShow] = useState([]);

  const handleParentButtonClick = () => {
    childRef.current.childButtonClickUpdate();
  };

  const handleClose = () => {
    setOpen(false);
  };

  const handleAgreeDelete = (value) => {
    setOpenCloseDialog(true);
  };

  const handleDelete = async () => {
    handleClose();
    setOpenCloseDialog(false);
  };
  React.useEffect(() => {
    if (open) {
      setModalChangeExe(false);
      setIsLoading(false);
      const newQuestions = data?.questions || [];
      let que_list = [];
      if (newQuestions && newQuestions.length > 0) {
        que_list = newQuestions.map((item) => {
          return {
            ...item,
            loading: [],
          };
        });
      }
      setQuestionsToSend(que_list);
      setEditShow(newQuestions.map(() => ({ display: false })));
    }
  }, [open]);

  return (
    <div>
      <CustomConfirmation
        openDelete={openCloseDialog}
        setOpenDelete={setOpenCloseDialog}
        title={"Are you sure you want to Close ?"}
        handleAgree={handleDelete}
      />
      <Dialog
        open={open}
        fullScreen={window.innerWidth <= 550 ? true : false}
        fullWidth
        maxWidth={"lg"}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
        id="show-dialog-on-full"
      >
        <div className="text-end mt-2 me-2">
          {modalChangeExe ? (
            <div className="d-flex align-items-baseline justify-content-between">
              <Alert
                sx={{
                  textAlign: "left",
                  width: "100%",
                  backgroundColor: "#ff7f00",
                  color: "#fff",
                  "& .MuiAlert-icon": {
                    color: "#fff",
                  },
                }}
                severity="warning"
              >
                You have unsaved changes. Remember to save them before closing.
              </Alert>
              <IconButton
                className="back-screen-button"
                onClick={handleAgreeDelete}
              >
                <CloseIcon />
              </IconButton>
            </div>
          ) : (
            <IconButton className="back-screen-button" onClick={handleClose}>
              <CloseIcon />
            </IconButton>
          )}
        </div>

        <DialogContent
          sx={{
            paddingY: 0,
            height: "80vh",
            overflowY: "auto",
          }}
        >
          <AddWorkoutCalender
            ref={childRef}
            date={date}
            programme={programme}
            setOpen={setOpen}
            editData={data}
            day={day}
            reloadList={reloadList}
            setIsLoading={setIsLoading}
            setModalChangeExe={setModalChangeExe}
            member_vdot={member_vdot}
            memberRewardData={memberRewardData}
            events={events}
            setEditWorkputData={setEditWorkputData}
            setEvents={setEvents}
            setSubmitted={setSubmitted}
            questionsToSend={questionsToSend}
            setQuestionsToSend={setQuestionsToSend}
            editShow={editShow}
            setEditShow={setEditShow}
          />
        </DialogContent>
        <DialogActions>
          <Button
            sx={{ textTransform: "inherit" }}
            onClick={handleParentButtonClick}
            size="small"
            color="primary"
            variant="contained"
            className="small-contained-dialog-button"
            disabled={isloading}
          >
            Save Changes
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
}
